import React, { useState, useEffect } from "react";
import { InputAdornment, TextField } from "@mui/material";

const UITextField_V2 = ({
  fieldLabel = "Field Label",
  value = "",
  onChange = () => {},
  autoFocus = false,
  required = false,
  multiline = false,
  rows = 1,
  type = "text",
  endAdornment,
  size = "small",
  ...props
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleSSNChange = (e) => {
    const { value } = e.target;
    let formattedValue = value.replace(/\D/g, "").slice(0, 9);

    if (formattedValue.length > 5) {
      formattedValue =
        formattedValue.slice(0, 3) +
        "-" +
        formattedValue.slice(3, 5) +
        "-" +
        formattedValue.slice(5);
    } else if (formattedValue.length > 3) {
      formattedValue =
        formattedValue.slice(0, 3) + "-" + formattedValue.slice(3);
    }

    setInputValue(formattedValue);

    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: formattedValue } });
    }
  };

  const handleChange = (e) => {
    if (type === "ssn") {
      handleSSNChange(e);
    } else if (onChange) {
      onChange(e);
    }
  };

  return (
    <div>
      <TextField
        required={required}
        multiline={multiline}
        label={fieldLabel}
        rows={rows}
        value={type === "ssn" ? inputValue : value}
        onChange={handleChange}
        size= {size}
        autoFocus={autoFocus}
        InputProps={{
          endAdornment: endAdornment && (
            <InputAdornment
              position="end"
              sx={{
                position: "absolute",
                right: 0,
                top: 20,
              }}
            >
              {endAdornment}
            </InputAdornment>
          ),
        }}
        type={type}
        {...props}
      />
    </div>
  );
};

export default UITextField_V2;
